const productPageMap = document.getElementById("map");
let mapInstance = null;

function readMapOptions() {
  const dataCoordinates = document.querySelector(".map__coordinates");
  if (!dataCoordinates) return null;

  const coordinateX = Number(dataCoordinates.dataset.x);
  const coordinateY = Number(dataCoordinates.dataset.y);
  if (!Number.isFinite(coordinateX) || !Number.isFinite(coordinateY)) return null;

  return {
    coordinateX,
    coordinateY,
    zoom: Number(dataCoordinates.dataset.zoom) || 17,
    placeMarker: dataCoordinates.dataset.placeMarker || "",
  };
}

function destroyMap() {
  if (mapInstance) {
    try {
      mapInstance.destroy();
    } catch (error) {
      // ignore
    }
    mapInstance = null;
  }
}

function init() {
  const options = readMapOptions();
  const mapNode = document.getElementById("map");
  if (!options || !mapNode || !window.ymaps) return;

  destroyMap();

  const center = [`${options.coordinateX}`, `${options.coordinateY}`];
  mapInstance = new window.ymaps.Map("map", {
    center,
    zoom: options.zoom,
  });

  const placemark = new window.ymaps.Placemark(
    center,
    {},
    {
      iconLayout: "default#image",
      iconImageHref: `${options.placeMarker}`,
      iconImageSize: [56, 82],
      iconImageOffset: [0, 0],
    },
  );

  mapInstance.controls.remove("geolocationControl");
  mapInstance.controls.remove("searchControl");
  mapInstance.controls.remove("trafficControl");
  mapInstance.controls.remove("typeSelector");
  mapInstance.controls.remove("rulerControl");
  mapInstance.behaviors.disable(["scrollZoom"]);
  mapInstance.geoObjects.add(placemark);
}

function initWhenReady() {
  if (!window.ymaps) return;
  window.ymaps.ready(init);
}

if (productPageMap && window.ymaps) {
  initWhenReady();
}

window.NMMap = {
  init,
  initWhenReady,
  destroyMap,
};
